<template>
  <div class="row">
    <div class="col-12 col-md-2">
      <input-select-search
        :label="$t(`ACADEMICO.ANO_LETIVO`)"
        :options="opcoes.anosLetivos"
        v-model="filtro.anoLetivoId"
        required
      />
    </div>
    <div class="col-12 col-md-2">
      <input-select-search
        ref="segmentacaoId"
        :label="$t(`ACADEMICO.SEGMENTACAO`)"
        :options="opcoes.segmentacoes"
        v-model="filtro.segmentacaoId"
        :isDisabled="desabilitar.segmentacao"
        required
      />
    </div>
    <div class="col-12 col-md-3">
      <input-select-search
        :label="$t(`ACADEMICO.CURSO`)"
        :options="opcoes.cursos"
        v-model="filtro.cursoId"
        :isDisabled="desabilitar.curso"
        required
      />
    </div>
    <div class="col-12 col-md-3">
      <input-select-search
        ref="turmaId"
        :label="$t(`ACADEMICO.TURMA`)"
        :options="opcoes.turmas"
        v-model="filtro.turmaId"
        :isDisabled="desabilitar.turma"
        required
      />
    </div>
    <div class="col-12 col-md-2">
      <input-select-search
        ref="disciplinaId"
        :label="$t(`ACADEMICO.DISCIPLINA`)"
        :options="opcoes.disciplinas"
        v-model="filtro.disciplinaId"
        :isDisabled="desabilitar.disciplina"
        required
      />
    </div>
    <div class="col-12 col-md-auto align-items-center">
      <b-button variant="primary" class="w-100" @click="filtrar">
        {{ $t('GERAL.FILTRAR') }}
      </b-button>
    </div>
    <div class="col-12 col-md-auto">
      <b-button
        variant="secondary"
        class="mt-3 mt-md-0 w-100"
        @click="limparFiltro"
      >
        {{ $t('GERAL.LIMPAR') }}
      </b-button>
    </div>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import CursoService from '@/common/services/academico/curso.service';
import TurmaService from '@/common/services/academico/turma.service';
import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import DisciplinasService from '@/common/services/academico/disciplinas.service';

// Components:
import { InputSelectSearch } from '@/components/inputs';

export default {
  components: {
    InputSelectSearch,
  },
  data() {
    return {
      filtro: {
        anoLetivoId: '',
        segmentacaoId: '',
        cursoId: '',
        turmaId: '',
        disciplinaId: '',
      },
      desabilitar: {
        turma: true,
        disciplina: true,
        segmentacao: true,
        curso: true,
      },
      opcoes: {
        anosLetivos: [],
        cursos: [],
        segmentacoes: [],
        turmas: [],
        disciplinas: [],
      },
    };
  },
  mounted() {
    this.getAnosLetivo();
    this.$emit('refs', this.$refs);
  },
  watch: {
    'filtro.anoLetivoId'(anoLetivoId) {
      if (anoLetivoId) {
        this.getCursos(anoLetivoId);
        this.getSegmentacoes();
      } else {
        this.opcoes.cursos = [];
        this.opcoes.turmas = [];
        this.opcoes.segmentacoes = [];
        this.desabilitar.curso = true;
        this.desabilitar.turma = true;
        this.desabilitar.segmentacao = true;
      }
      this.filtro.cursoId = null;
      this.filtro.turmaId = null;
      this.filtro.segmentacaoId = null;
    },
    'filtro.cursoId': {
      handler(novoCursoId) {
        if (novoCursoId) {
          this.getTurmas();
        } else {
          this.desabilitar.disciplina = true;
          this.desabilitar.turma = true;
          this.opcoes.turmas = [];
          this.opcoes.disciplinas = [];
        }
        this.filtro.turmaId = null;
        this.filtro.disciplinaId = null;
      },
    },
    'filtro.turmaId': {
      handler(turmaId) {
        if (turmaId) {
          this.getDisciplinas();
        } else {
          this.desabilitar.disciplina = true;
          this.opcoes.disciplinas = [];
        }
        this.filtro.disciplinaId = null;
      },
    },
  },
  methods: {
    getAnosLetivo() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar(this.paginacao)
        .then(({ data }) => {
          data.forEach((element) => {
            element.text = element.ano;
            element.value = element.id;
          });
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getSegmentacoes() {
      this.opcoes.anosLetivos.forEach((element) => {
        if (element.id == this.filtro.anoLetivoId) {
          this.opcoes.segmentacoes = element.segmentacoes;
          this.opcoes.segmentacoes.forEach((segmentacao) => {
            segmentacao.text = segmentacao.descricao;
            segmentacao.value = segmentacao.id;
          });
          this.desabilitar.segmentacao = false;
        }
      });
    },
    getCursos(anoLetivoId) {
      this.$store.dispatch(START_LOADING);
      CursoService.obterPorAnoLetivo(anoLetivoId)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.cursos = data;
          this.desabilitar.curso = false;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getTurmas() {
      this.$store.dispatch(START_LOADING);
      TurmaService.buscarPorCursoAnoLetivo(this.filtro)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.turmas = data;
          this.habilitarCampo('turma');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getDisciplinas() {
      this.$store.dispatch(START_LOADING);
      DisciplinasService.buscarPorTurmaId(this.filtro.turmaId)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.disciplinas = data;
          this.habilitarCampo('disciplina');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    habilitarCampo(key) {
      this.desabilitar[key] = false;
    },
    // FUNÇÕES FILTRO:
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      if (!this.validarFiltro()) return;
      this.$emit('filtrar', JSON.parse(JSON.stringify(this.filtro)));
    },
    limparFiltro() {
      this.filtro = {
        cursoId: '',
        segmentacaoId: '',
        turmaId: '',
        disciplinaId: '',
      };
      this.$emit('limparFiltro');
    },
  },
};
</script>
